import { Button, Form, Input, Select, message } from 'antd';
import { useEffect, useState } from 'react';
import { SendSysMsgReq, sendSysMsg, getSysMsgKinds, SysNoticeKind } from '@/services/api/bohrium';

export const Notice = () => {
    const [loading, setLoading] = useState(false);
    const [noticeKinds, setNoticeKinds] = useState<SysNoticeKind[]>([]);
    const [form] = Form.useForm();
    useEffect(() => {
        getSysMsgKinds()
            .then(response => {
                const formattedOptions = (response.data as SysNoticeKind[]).map(item => ({
                    name: item.name,
                    id: item.id,
                }));
                setNoticeKinds(formattedOptions);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);
    return (
        <div>
            <Form
                form={form}
                name="basic"
                labelCol={{ span: 6 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                autoComplete="off"
            >
                <Form.Item label="用户id" name="user_ids" rules={[{ required: true, message: '请输入' }]}>
                    <Input.TextArea placeholder="请输入用户的唯一标识符，多个用户ID可以用逗号分隔" />
                </Form.Item>
                <Form.Item label="中文信息" name="msg_cn" rules={[{ required: true, message: '请输入' }]}>
                    <Input.TextArea placeholder="请填写，限255字符" maxLength={255} />
                </Form.Item>
                <Form.Item label="英文信息" name="msg_en" rules={[{ required: true, message: '请输入' }]}>
                    <Input.TextArea placeholder="请填写，限255字符" maxLength={255} />
                </Form.Item>
                <Form.Item label="类型" name="kind" rules={[{ required: true, message: '请选择' }]}>
                    <Select>
                        {noticeKinds.map(
                            item =>
                                item.id !== undefined && (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.name}
                                    </Select.Option>
                                )
                        )}
                    </Select>
                </Form.Item>
                <Form.Item>
                    <Button
                        style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                        onClick={() => {
                            setLoading(true);
                            const msgReq: SendSysMsgReq = {
                                userIds: form.getFieldValue('user_ids'),
                                msgCN: form.getFieldValue('msg_cn'),
                                msgEN: form.getFieldValue('msg_en'),
                                kind: form.getFieldValue('kind'),
                            };
                            sendSysMsg(msgReq)
                                .then(ret => {
                                    console.log(ret);
                                    setLoading(false);
                                    message.success('发送成功');
                                })
                                .catch(error => {
                                    console.error(error);
                                    setLoading(false);
                                    message.error('发送失败');
                                });
                        }}
                    >
                        发送
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};
